import React from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles, createStyles } from '@material-ui/core';
import { Heading, Button, Divider, TextBlock, ExtendedTheme } from 'neon-design-system';

interface StyleProps {
	showHeader: boolean;
}

const useStyles = makeStyles<ExtendedTheme, StyleProps>(theme => createStyles({
	headerMainDiv: {
		marginTop: (props) => !props.showHeader ? theme.spacing(0) : theme.spacing(2),
		display: 'flex',
		justifyContent: 'space-between'
	},
	info: {
		marginTop: theme.spacing(2)
	},
	divider: {
		marginTop: theme.spacing(2),
		marginBottom: theme.spacing(2)
	},
	secondaryButton: {
		marginRight: theme.spacing(1)
	}
}));

export interface HeaderProps {
	title?: string;
	addNewUrl: string;
	toolbar?: React.ReactNode;
	showAdd: boolean;
	showSecondaryButton: boolean;
	pageCaption?: string;
	showHeader?: boolean;
	addButtonLabel?: string;
	secondaryButtonLabel?: string;
	entityForCaptionText?: string;
	secondaryButtonUrl: string;
}

const getHeaderCaptionEntity = (entityForCaptionText: string | undefined, title: string | undefined) => {
	if(!entityForCaptionText) {
		return `${title ? title.toLowerCase() : ''}`;
	}

	return entityForCaptionText.toLowerCase();
}

const ListPageHeader = ({
	title,
	addNewUrl,
	secondaryButtonUrl = '',
	toolbar,
	showAdd,
	showSecondaryButton,
	pageCaption,
	showHeader = true,
	addButtonLabel = '',
	secondaryButtonLabel = '',
	entityForCaptionText = ''
}: HeaderProps): JSX.Element => {
	const classes = useStyles({ showHeader : !!showHeader });
	const history = useHistory();
	return (
		<div>
			<div className={classes.headerMainDiv}>
				{showHeader && <div id="list-page-header-title"><Heading styleName="title1">{title}</Heading></div>}
				<div>
					{
						showSecondaryButton && <Button
							className={classes.secondaryButton}
							id="secondary-action-button"
							colorType="grey"
							onClick={(): void => {
								history.push(secondaryButtonUrl);
							}}
						>
							{secondaryButtonLabel}
						</Button>
					}
					{showAdd && <Button
						id={'add-new-item-button'}
						colorType="primary"
						onClick={(): void => {
							history.push(addNewUrl);
						}}
					>
						{!addButtonLabel ? 'Add new' : addButtonLabel}
					</Button>}
				</div>
			</div>
			{showHeader && <Divider className={classes.divider} />}
			<div>
				{toolbar}
			</div>
			{(pageCaption) ?
				<div className={classes.info}>
					<TextBlock styleName="caption1" color="grey" shade={400}>
						Showing {pageCaption} {getHeaderCaptionEntity(entityForCaptionText, title)}
					</TextBlock>
				</div>
				: null}
		</div>

	);
};

export default ListPageHeader;
